/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../../../../componentLibrary/Tooltip';
import UserAvatar from './UserAvatar';
import * as Styled from './styles';

const ConnectedUsers = ({ users }) => {
    const shouldConsolidate = users.length > 3;
    const moreUsersDetails = [];

    return (
        <Styled.ConnectedUsers>
            <Styled.UsersWrapper>
                {users.map((user, idx) => {
                    const tooltipId = `${user.firstName}${idx}`;
                    let useEmail = user.firstName === 'N/A' || user.firstName === 'NA';
                    let identifier = useEmail ? user.email : `${user.firstName} ${user.lastName}`;
                    let isBananatagSupport = false;

                    // If anyone is inside BTag offices or using VPN and logged in as a
                    // non-bananatag email, the identifier will be replaced to represent
                    // a bananatag employee.
                    if (user.isIPFromBananaTagOffice && !user.email.includes('@bananatag')) {
                        useEmail = false;
                        identifier = 'Bananatag Support';
                        isBananatagSupport = true;
                    }

                    if (idx >= 3) {
                        moreUsersDetails.push(identifier);
                        return null;
                    }

                    return (
                        <Tooltip key={`${identifier}-${idx}-key`} id={tooltipId} text={identifier}>
                            <UserAvatar user={user} useEmail={useEmail} useLogo={isBananatagSupport} />
                        </Tooltip>
                    );
                })}
            </Styled.UsersWrapper>
            {shouldConsolidate && (
                <Tooltip id="moreUsers" text={moreUsersDetails.map((user, idx) => <p key={`${user.email}-${idx}-key`} style={{ marginBottom: 4 }}>{user}</p>)}>
                    <Styled.MoreUsers>
                        {`+${users.length - 3} more`}
                    </Styled.MoreUsers>
                </Tooltip>
            )}
        </Styled.ConnectedUsers>
    );
};

ConnectedUsers.propTypes = {
    users: PropTypes.array.isRequired,
};

export default ConnectedUsers;
